import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import ExternalApi from '@/modules/core/api/external.api.ts';

export class ExternalQueryOptions {
  static BASE_KEY = 'external';

  static getBanksCBRF(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, ExternalQueryOptions.BASE_KEY],
      queryFn: (meta) => ExternalApi.getBanksCBRF(signal ?? meta.signal),
    });
  }
}
